enum productPackageTypeEnum {
  NON_VEGETARIAN = 'Non-vegetarian',
  VEGETARIAN = 'Vegetarian',
  VEGAN = 'Vegan',
};

export default productPackageTypeEnum;